import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { promoCodes } from 'src/constants'
import { commonSubtitleText, commonTitleText } from 'src/modules/utils/constants'

export default (props) => {
  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      offerBanner={{
        title: [
          'Special Offer for Planet Fitness Members:',
          'Save $30/mo off your first two months.',
        ],
      }}
      offerCode={promoCodes.planet_fitness}
      title={commonTitleText.streamLiveTVSports}
      subtitle={commonSubtitleText.onAnyDevice}
      logo={'https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-planet-fitness.png'}
      logoHeight={'80px'}
      noIndex={true}
    />
  )
}
